/**
 * Collection quick filter tabs.
 *
 * The pills are plain links to filter URLs, so they work without JS. When the theme's
 * <filter-container> is doing ajax filtering we hand the URL to it instead, so the grid swaps in
 * place like every other filter. Delegated from document because the pill row lives inside a
 * [data-ajax-container] and is replaced on every refresh.
 *
 * Shopify only exposes a facet's 100 most common values, and only reports a filter as active
 * when its value is one of them. With a few hundred tags per collection the less common STYLE
 * tags sit outside that window: the filter still applies, but Liquid never sees it, so the pill
 * would not highlight and the value would be dropped the moment another filter changed (the
 * filter form is rebuilt from its inputs alone). The URL is the truth, so both are synced from it.
 */
(function () {
  var NAV_SELECTOR = '.quick-filters';
  var PILL_SELECTOR = '.quick-filters__pill';
  var ACTIVE_CLASS = 'quick-filters__pill--active';
  var FORM_ID = 'CollectionFilterForm';

  document.addEventListener('click', function (evt) {
    var pill = evt.target.closest(PILL_SELECTOR);
    if (!pill || pill.classList.contains(ACTIVE_CLASS)) return;

    var section = pill.closest('.shopify-section');
    var container = section && section.querySelector('filter-container[data-ajax-filtering="true"]');
    if (!container || typeof container.ajaxLoadUrl !== 'function') return;

    evt.preventDefault();
    container.ajaxLoadUrl(pill.href);
  });

  function paramValues(search, param) {
    return new URLSearchParams(search).getAll(param);
  }

  // Highlight whichever pill matches the current URL, and make sure every selected value is in
  // the filter form so changing another filter keeps it.
  function syncFromUrl() {
    var nav = document.querySelector(NAV_SELECTOR);
    var param = nav && nav.getAttribute('data-param');
    if (!param) return;

    var current = paramValues(window.location.search, param);

    nav.querySelectorAll(PILL_SELECTOR).forEach(function (pill) {
      var mine = paramValues(new URL(pill.href, window.location.origin).search, param);
      var active = mine.length
        ? mine.some(function (value) { return current.indexOf(value) !== -1; })
        : current.length === 0; // the "all" pill has no value of its own

      pill.classList.toggle(ACTIVE_CLASS, active);
      if (active) {
        pill.setAttribute('aria-current', 'true');
      } else {
        pill.removeAttribute('aria-current');
      }
    });

    var form = document.getElementById(FORM_ID);
    if (!form) return;

    var present = Array.prototype.map.call(
      form.querySelectorAll('input[type="hidden"][name="' + param + '"]'),
      function (input) { return input.value; }
    );

    current.forEach(function (value) {
      if (present.indexOf(value) !== -1) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = param;
      input.value = value;
      form.appendChild(input);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromUrl);
  } else {
    syncFromUrl();
  }

  document.addEventListener('filters-loaded', function () {
    syncFromUrl();

    // The strip resets to scrollLeft 0 when it is re-rendered, which hides the selected tab on
    // mobile. Bring it back into view once the new markup is in.
    var active = document.querySelector('.quick-filters__scroller .' + ACTIVE_CLASS);
    if (!active) return;

    var scroller = active.parentElement;
    if (scroller.scrollWidth <= scroller.clientWidth) return;

    scroller.scrollLeft = active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
  });
})();
